import { drop } from "lodash";

export function getRoleFromJson(content){
    const dropSelects =  content.Opening.filter(e => e.element === 'DropdownSelect:').map(roleObj => {
        for(let lang in roleObj){
            if(roleObj[lang].trim() === roleObj[lang]) continue;

            roleObj[lang] = roleObj[lang].trim();
        }

        delete roleObj.element;

        return roleObj;
    });  

    return dropSelects;
}